import o from "./SVGs/addToFolder.svg.mjs";
import r from "./SVGs/addedtoFolder.svg.mjs";
import t from "./SVGs/aiWand.svg.mjs";
import e from "./SVGs/alarmBell.svg.mjs";
import i from "./SVGs/alignBottom.svg.mjs";
import n from "./SVGs/alignCenter.svg.mjs";
import l from "./SVGs/alignLeft.svg.mjs";
import m from "./SVGs/alignMiddle.svg.mjs";
import a from "./SVGs/alignRight.svg.mjs";
import c from "./SVGs/alignTop.svg.mjs";
import s from "./SVGs/amex.svg.mjs";
import p from "./SVGs/applePay.svg.mjs";
import g from "./SVGs/arrowBack.svg.mjs";
import S from "./SVGs/arrowCursor_blue.svg.mjs";
import f from "./SVGs/arrowCursor_pink.svg.mjs";
import v from "./SVGs/arrowCursor_yellow.svg.mjs";
import u from "./SVGs/arrowDown.svg.mjs";
import d from "./SVGs/arrowRight.svg.mjs";
import w from "./SVGs/arrowUp.svg.mjs";
import k from "./SVGs/attachment.svg.mjs";
import P from "./SVGs/audioModified.svg.mjs";
import B from "./SVGs/blankCalendar_blue.svg.mjs";
import C from "./SVGs/blankCalendar_pink.svg.mjs";
import h from "./SVGs/blankCalendar_yellow.svg.mjs";
import Y from "./SVGs/brain.svg.mjs";
import y from "./SVGs/businessStartup_blue.svg.mjs";
import A from "./SVGs/businessStartup_pink.svg.mjs";
import b from "./SVGs/businessStartup_yellow.svg.mjs";
import M from "./SVGs/calendar.svg.mjs";
import V from "./SVGs/cameraVideo_blue.svg.mjs";
import I from "./SVGs/cameraVideo_pink.svg.mjs";
import L from "./SVGs/cameraVideo_yellow.svg.mjs";
import T from "./SVGs/camera_blue.svg.mjs";
import F from "./SVGs/camera_pink.svg.mjs";
import H from "./SVGs/camera_yellow.svg.mjs";
import E from "./SVGs/chatBubbleTypingOval_blue.svg.mjs";
import G from "./SVGs/chatBubbleTypingOval_pink.svg.mjs";
import U from "./SVGs/chatBubbleTypingOval_yellow.svg.mjs";
import W from "./SVGs/chatTwoBubblesSquare_blue.svg.mjs";
import D from "./SVGs/chatTwoBubblesSquare_pink.svg.mjs";
import x from "./SVGs/chatTwoBubblesSquare_yellow.svg.mjs";
import O from "./SVGs/check.svg.mjs";
import R from "./SVGs/checkCircle.svg.mjs";
import q from "./SVGs/chevronDown.svg.mjs";
import N from "./SVGs/chevronLeft.svg.mjs";
import K from "./SVGs/chevronRight.svg.mjs";
import z from "./SVGs/chevronUp.svg.mjs";
import Q from "./SVGs/circleCheck.svg.mjs";
import Z from "./SVGs/circleClock_black.svg.mjs";
import j from "./SVGs/circleClock_blue.svg.mjs";
import J from "./SVGs/circleClock_pink.svg.mjs";
import X from "./SVGs/circleClock_yellow.svg.mjs";
import _ from "./SVGs/close.svg.mjs";
import $ from "./SVGs/cog.svg.mjs";
import oo from "./SVGs/collapseContent.svg.mjs";
import ro from "./SVGs/compass.svg.mjs";
import to from "./SVGs/controlsForward.svg.mjs";
import eo from "./SVGs/controlsPause.svg.mjs";
import io from "./SVGs/controlsPlay.svg.mjs";
import no from "./SVGs/controlsRecord.svg.mjs";
import lo from "./SVGs/controlsRewind.svg.mjs";
import mo from "./SVGs/controlsStop.svg.mjs";
import ao from "./SVGs/dashboardGauge_blue.svg.mjs";
import co from "./SVGs/dashboardGauge_pink.svg.mjs";
import so from "./SVGs/dashboardGauge_yellow.svg.mjs";
import po from "./SVGs/dinersClub.svg.mjs";
import go from "./SVGs/discover.svg.mjs";
import So from "./SVGs/downloadBottom.svg.mjs";
import fo from "./SVGs/downloadSquare_blue.svg.mjs";
import vo from "./SVGs/downloadSquare_pink.svg.mjs";
import uo from "./SVGs/downloadSquare_yellow.svg.mjs";
import wo from "./SVGs/dropbox.svg.mjs";
import ko from "./SVGs/emptyClipboard_blue.svg.mjs";
import Po from "./SVGs/emptyClipboard_pink.svg.mjs";
import Bo from "./SVGs/emptyClipboard_yellow.svg.mjs";
import Co from "./SVGs/erlenmeyerFlask_blue.svg.mjs";
import ho from "./SVGs/erlenmeyerFlask_pink.svg.mjs";
import Yo from "./SVGs/erlenmeyerFlask_yellow.svg.mjs";
import yo from "./SVGs/error.svg.mjs";
import Ao from "./SVGs/expandContent.svg.mjs";
import bo from "./SVGs/expandHorizontal.svg.mjs";
import Mo from "./SVGs/expandVertical.svg.mjs";
import Vo from "./SVGs/facebook.svg.mjs";
import Io from "./SVGs/favorite.svg.mjs";
import Lo from "./SVGs/favoriteFilled.svg.mjs";
import To from "./SVGs/fileDouble.svg.mjs";
import Fo from "./SVGs/filter.svg.mjs";
import Ho from "./SVGs/filterImage.svg.mjs";
import Eo from "./SVGs/filterMusic.svg.mjs";
import Go from "./SVGs/filterPlus.svg.mjs";
import Uo from "./SVGs/filterVideo.svg.mjs";
import Wo from "./SVGs/folderStar.svg.mjs";
import Do from "./SVGs/generateImage.svg.mjs";
import xo from "./SVGs/generateVideo.svg.mjs";
import Oo from "./SVGs/gitHub.svg.mjs";
import Ro from "./SVGs/googlePay.svg.mjs";
import qo from "./SVGs/graphPieChart_blue.svg.mjs";
import No from "./SVGs/graphPieChart_pink.svg.mjs";
import Ko from "./SVGs/graphPieChart_yellow.svg.mjs";
import zo from "./SVGs/gridRules_blue.svg.mjs";
import Qo from "./SVGs/gridRules_pink.svg.mjs";
import Zo from "./SVGs/gridRules_yellow.svg.mjs";
import jo from "./SVGs/happyFace_blue.svg.mjs";
import Jo from "./SVGs/happyFace_pink.svg.mjs";
import Xo from "./SVGs/happyFace_yellow.svg.mjs";
import _o from "./SVGs/headphonesCustomer.svg.mjs";
import $o from "./SVGs/helpChat_blue.svg.mjs";
import or from "./SVGs/helpChat_pink.svg.mjs";
import rr from "./SVGs/helpChat_yellow.svg.mjs";
import tr from "./SVGs/home_blue.svg.mjs";
import er from "./SVGs/home_pink.svg.mjs";
import ir from "./SVGs/home_yellow.svg.mjs";
import nr from "./SVGs/hourGlass_blue.svg.mjs";
import lr from "./SVGs/hourGlass_pink.svg.mjs";
import mr from "./SVGs/hourGlass_yellow.svg.mjs";
import ar from "./SVGs/house.svg.mjs";
import cr from "./SVGs/image.svg.mjs";
import sr from "./SVGs/imageModified.svg.mjs";
import pr from "./SVGs/informationCircle.svg.mjs";
import gr from "./SVGs/informationCircleInverted.svg.mjs";
import Sr from "./SVGs/instagram.svg.mjs";
import fr from "./SVGs/interfaceAlertAlarmBell_blue.svg.mjs";
import vr from "./SVGs/interfaceAlertAlarmBell_pink.svg.mjs";
import ur from "./SVGs/interfaceAlertAlarmBell_yellow.svg.mjs";
import dr from "./SVGs/interfaceAwardTrophy_blue.svg.mjs";
import wr from "./SVGs/interfaceAwardTrophy_pink.svg.mjs";
import kr from "./SVGs/interfaceAwardTrophy_yellow.svg.mjs";
import Pr from "./SVGs/interfaceCursorArrow_blue.svg.mjs";
import Br from "./SVGs/interfaceCursorArrow_pink.svg.mjs";
import Cr from "./SVGs/interfaceCursorArrow_yellow.svg.mjs";
import hr from "./SVGs/interfaceFavoriteLike_blue.svg.mjs";
import Yr from "./SVGs/interfaceFavoriteLike_pink.svg.mjs";
import yr from "./SVGs/interfaceFavoriteLike_yellow.svg.mjs";
import Ar from "./SVGs/interfaceImageVideoAudioSubtitles_blue.svg.mjs";
import br from "./SVGs/interfaceImageVideoAudioSubtitles_pink.svg.mjs";
import Mr from "./SVGs/interfaceImageVideoAudioSubtitles_yellow.svg.mjs";
import Vr from "./SVGs/interfaceLightingLightBulb_blue.svg.mjs";
import Ir from "./SVGs/interfaceLightingLightBulb_pink.svg.mjs";
import Lr from "./SVGs/interfaceLightingLightBulb_yellow.svg.mjs";
import Tr from "./SVGs/interfaceSearch_blue.svg.mjs";
import Fr from "./SVGs/interfaceSearch_pink.svg.mjs";
import Hr from "./SVGs/interfaceSearch_yellow.svg.mjs";
import Er from "./SVGs/keep.svg.mjs";
import Gr from "./SVGs/keyboardArrowRight.svg.mjs";
import Ur from "./SVGs/keyboard_blue.svg.mjs";
import Wr from "./SVGs/keyboard_pink.svg.mjs";
import Dr from "./SVGs/keyboard_yellow.svg.mjs";
import xr from "./SVGs/layers_blue.svg.mjs";
import Or from "./SVGs/layers_pink.svg.mjs";
import Rr from "./SVGs/layers_yellow.svg.mjs";
import qr from "./SVGs/layoutWindow_blue.svg.mjs";
import Nr from "./SVGs/layoutWindow_pink.svg.mjs";
import Kr from "./SVGs/layoutWindow_yellow.svg.mjs";
import zr from "./SVGs/linkedIn.svg.mjs";
import Qr from "./SVGs/loadingRing.svg.mjs";
import Zr from "./SVGs/lock.svg.mjs";
import jr from "./SVGs/lockUnlock.svg.mjs";
import Jr from "./SVGs/login_blue.svg.mjs";
import Xr from "./SVGs/login_pink.svg.mjs";
import _r from "./SVGs/login_yellow.svg.mjs";
import $r from "./SVGs/logoStoryblocks.svg.mjs";
import ot from "./SVGs/logoStoryblocksGray.svg.mjs";
import rt from "./SVGs/logoStoryblocksWhite.svg.mjs";
import tt from "./SVGs/maestro.svg.mjs";
import et from "./SVGs/magicWand_blue.svg.mjs";
import it from "./SVGs/magicWand_pink.svg.mjs";
import nt from "./SVGs/magicWand_yellow.svg.mjs";
import lt from "./SVGs/maker.svg.mjs";
import mt from "./SVGs/mastercard.svg.mjs";
import at from "./SVGs/meetingCamera.svg.mjs";
import ct from "./SVGs/megaphone_blue.svg.mjs";
import st from "./SVGs/megaphone_pink.svg.mjs";
import pt from "./SVGs/megaphone_yellow.svg.mjs";
import gt from "./SVGs/microphone.svg.mjs";
import St from "./SVGs/microphoneOff.svg.mjs";
import ft from "./SVGs/moneyCashBill_blue.svg.mjs";
import vt from "./SVGs/moneyCashBill_pink.svg.mjs";
import ut from "./SVGs/moneyCashBill_yellow.svg.mjs";
import dt from "./SVGs/moneyWallet_blue.svg.mjs";
import wt from "./SVGs/moneyWallet_pink.svg.mjs";
import kt from "./SVGs/moneyWallet_yellow.svg.mjs";
import Pt from "./SVGs/musicSound.svg.mjs";
import Bt from "./SVGs/navigationMenuHorizontal.svg.mjs";
import Ct from "./SVGs/navigationMenuVertical.svg.mjs";
import ht from "./SVGs/newStickyNote_blue.svg.mjs";
import Yt from "./SVGs/newStickyNote_pink.svg.mjs";
import yt from "./SVGs/newStickyNote_yellow.svg.mjs";
import At from "./SVGs/oneFingerTap_blue.svg.mjs";
import bt from "./SVGs/oneFingerTap_pink.svg.mjs";
import Mt from "./SVGs/oneFingerTap_yellow.svg.mjs";
import Vt from "./SVGs/openBook_blue.svg.mjs";
import It from "./SVGs/openBook_pink.svg.mjs";
import Lt from "./SVGs/openBook_yellow.svg.mjs";
import Tt from "./SVGs/panelCollapse.svg.mjs";
import Ft from "./SVGs/panelExpand.svg.mjs";
import Ht from "./SVGs/paragraphLeftAlign.svg.mjs";
import Et from "./SVGs/paragraphsCenterAlign.svg.mjs";
import Gt from "./SVGs/paragraphsRightAlign.svg.mjs";
import Ut from "./SVGs/payPal.svg.mjs";
import Wt from "./SVGs/pen_blue.svg.mjs";
import Dt from "./SVGs/pen_pink.svg.mjs";
import xt from "./SVGs/pen_yellow.svg.mjs";
import Ot from "./SVGs/pencil.svg.mjs";
import Rt from "./SVGs/picturesFolderMemories_blue.svg.mjs";
import qt from "./SVGs/picturesFolderMemories_pink.svg.mjs";
import Nt from "./SVGs/picturesFolderMemories_yellow.svg.mjs";
import Kt from "./SVGs/pin_blue.svg.mjs";
import zt from "./SVGs/pin_pink.svg.mjs";
import Qt from "./SVGs/pin_yellow.svg.mjs";
import Zt from "./SVGs/pinterest.svg.mjs";
import jt from "./SVGs/playList_blue.svg.mjs";
import Jt from "./SVGs/playList_pink.svg.mjs";
import Xt from "./SVGs/playList_yellow.svg.mjs";
import _t from "./SVGs/playVideo.svg.mjs";
import $t from "./SVGs/plus.svg.mjs";
import oe from "./SVGs/profileAvatar.svg.mjs";
import re from "./SVGs/questionmark.svg.mjs";
import te from "./SVGs/refresh.svg.mjs";
import ee from "./SVGs/screenTv_blue.svg.mjs";
import ie from "./SVGs/screenTv_pink.svg.mjs";
import ne from "./SVGs/screenTv_yellow.svg.mjs";
import le from "./SVGs/script_blue.svg.mjs";
import me from "./SVGs/script_pink.svg.mjs";
import ae from "./SVGs/script_yellow.svg.mjs";
import ce from "./SVGs/search.svg.mjs";
import se from "./SVGs/searchSimilar.svg.mjs";
import pe from "./SVGs/settingMenu.svg.mjs";
import ge from "./SVGs/share.svg.mjs";
import Se from "./SVGs/shoppingCart_blue.svg.mjs";
import fe from "./SVGs/shoppingCart_pink.svg.mjs";
import ve from "./SVGs/shoppingCart_yellow.svg.mjs";
import ue from "./SVGs/snapchat.svg.mjs";
import de from "./SVGs/sparkle.svg.mjs";
import we from "./SVGs/sparkles.svg.mjs";
import ke from "./SVGs/stamp.svg.mjs";
import Pe from "./SVGs/starFourSided.svg.mjs";
import Be from "./SVGs/stopwatch_blue.svg.mjs";
import Ce from "./SVGs/stopwatch_pink.svg.mjs";
import he from "./SVGs/stopwatch_yellow.svg.mjs";
import Ye from "./SVGs/stripe.svg.mjs";
import ye from "./SVGs/sunCloud_blue.svg.mjs";
import Ae from "./SVGs/sunCloud_pink.svg.mjs";
import be from "./SVGs/sunCloud_yellow.svg.mjs";
import Me from "./SVGs/textBold.svg.mjs";
import Ve from "./SVGs/textInputArea.svg.mjs";
import Ie from "./SVGs/textItalic.svg.mjs";
import Le from "./SVGs/textStrikeThrough.svg.mjs";
import Te from "./SVGs/textStyle.svg.mjs";
import Fe from "./SVGs/textUnderline.svg.mjs";
import He from "./SVGs/thirdEye.svg.mjs";
import Ee from "./SVGs/thumbDown.svg.mjs";
import Ge from "./SVGs/thumbUp.svg.mjs";
import Ue from "./SVGs/trash.svg.mjs";
import We from "./SVGs/travelMapEarth_blue.svg.mjs";
import De from "./SVGs/travelMapEarth_pink.svg.mjs";
import xe from "./SVGs/travelMapEarth_yellow.svg.mjs";
import Oe from "./SVGs/twitter.svg.mjs";
import Re from "./SVGs/uploadBottom.svg.mjs";
import qe from "./SVGs/uploadCircle_blue.svg.mjs";
import Ne from "./SVGs/uploadCircle_pink.svg.mjs";
import Ke from "./SVGs/uploadCircle_yellow.svg.mjs";
import ze from "./SVGs/userCircleSingle_blue.svg.mjs";
import Qe from "./SVGs/userCircleSingle_pink.svg.mjs";
import Ze from "./SVGs/userCircleSingle_yellow.svg.mjs";
import je from "./SVGs/userSingle_blue.svg.mjs";
import Je from "./SVGs/userSingle_pink.svg.mjs";
import Xe from "./SVGs/userSingle_yellow.svg.mjs";
import _e from "./SVGs/venmo.svg.mjs";
import $e from "./SVGs/verticalSliderSquare_blue.svg.mjs";
import oi from "./SVGs/verticalSliderSquare_pink.svg.mjs";
import ri from "./SVGs/verticalSliderSquare_yellow.svg.mjs";
import ti from "./SVGs/video.svg.mjs";
import ei from "./SVGs/videoEditPeel.svg.mjs";
import ii from "./SVGs/videoEditSplit.svg.mjs";
import ni from "./SVGs/videoModified.svg.mjs";
import li from "./SVGs/videoPlayerAlternate.svg.mjs";
import mi from "./SVGs/view.svg.mjs";
import ai from "./SVGs/viewOff.svg.mjs";
import ci from "./SVGs/visa.svg.mjs";
import si from "./SVGs/voiceMail_blue.svg.mjs";
import pi from "./SVGs/voiceMail_pink.svg.mjs";
import gi from "./SVGs/voiceMail_yellow.svg.mjs";
import Si from "./SVGs/volumeDown.svg.mjs";
import fi from "./SVGs/volumeLevelHigh_blue.svg.mjs";
import vi from "./SVGs/volumeLevelHigh_pink.svg.mjs";
import ui from "./SVGs/volumeLevelHigh_yellow.svg.mjs";
import di from "./SVGs/volumeMedium.svg.mjs";
import wi from "./SVGs/volumeOff.svg.mjs";
import ki from "./SVGs/volumeUp.svg.mjs";
import Pi from "./SVGs/warningTriangle.svg.mjs";
import Bi from "./SVGs/waveform.svg.mjs";
import Ci from "./SVGs/webcamVideo_blue.svg.mjs";
import hi from "./SVGs/webcamVideo_pink.svg.mjs";
import Yi from "./SVGs/webcamVideo_yellow.svg.mjs";
import yi from "./SVGs/youtube.svg.mjs";
import Ai from "./SVGs/zap.svg.mjs";
const os = o, rs = r, ts = t, es = e, is = i, ns = n, ls = l, ms = m, as = a, cs = c, ss = s, ps = p, gs = g, Ss = S, fs = f, vs = v, us = u, ds = d, ws = w, ks = k, Ps = P, Bs = B, Cs = C, hs = h, Ys = Y, ys = y, As = A, bs = b, Ms = M, Vs = T, Is = F, Ls = H, Ts = V, Fs = I, Hs = L, Es = E, Gs = G, Us = U, Ws = W, Ds = D, xs = x, Os = O, Rs = R, qs = q, Ns = N, Ks = K, zs = z, Qs = Q, Zs = Z, js = j, Js = J, Xs = X, _s = _, $s = $, op = oo, rp = ro, tp = to, ep = eo, ip = io, np = no, lp = lo, mp = mo, ap = ao, cp = co, sp = so, pp = po, gp = go, Sp = So, fp = fo, vp = vo, up = uo, dp = wo, wp = ko, kp = Po, Pp = Bo, Bp = Co, Cp = ho, hp = Yo, Yp = yo, yp = Ao, Ap = bo, bp = Mo, Mp = Vo, Vp = Io, Ip = Lo, Lp = To, Tp = Fo, Fp = Ho, Hp = Eo, Ep = Go, Gp = Uo, Up = Wo, Wp = Do, Dp = xo, xp = Oo, Op = Ro, Rp = qo, qp = No, Np = Ko, Kp = zo, zp = Qo, Qp = Zo, Zp = jo, jp = Jo, Jp = Xo, Xp = _o, _p = $o, $p = or, og = rr, rg = tr, tg = er, eg = ir, ig = nr, ng = lr, lg = mr, mg = ar, ag = cr, cg = sr, sg = pr, pg = gr, gg = Sr, Sg = fr, fg = vr, vg = ur, ug = dr, dg = wr, wg = kr, kg = Pr, Pg = Br, Bg = Cr, Cg = hr, hg = Yr, Yg = yr, yg = Ar, Ag = br, bg = Mr, Mg = Vr, Vg = Ir, Ig = Lr, Lg = Tr, Tg = Fr, Fg = Hr, Hg = Er, Eg = Ur, Gg = Wr, Ug = Dr, Wg = Gr, Dg = xr, xg = Or, Og = Rr, Rg = qr, qg = Nr, Ng = Kr, Kg = zr, zg = Qr, Qg = Zr, Zg = jr, jg = Jr, Jg = Xr, Xg = _r, _g = $r, $g = ot, oS = rt, rS = tt, tS = et, eS = it, iS = nt, nS = lt, lS = mt, mS = at, aS = ct, cS = st, sS = pt, pS = gt, gS = St, SS = ft, fS = vt, vS = ut, uS = dt, dS = wt, wS = kt, kS = Pt, PS = Bt, BS = Ct, CS = ht, hS = Yt, YS = yt, yS = At, AS = bt, bS = Mt, MS = Vt, VS = It, IS = Lt, LS = Tt, TS = Ft, FS = Ht, HS = Et, ES = Gt, GS = Ut, US = Wt, WS = Dt, DS = xt, xS = Ot, OS = Rt, RS = qt, qS = Nt, NS = Kt, KS = zt, zS = Qt, QS = Zt, ZS = jt, jS = Jt, JS = Xt, XS = _t, _S = $t, $S = oe, of = re, rf = te, tf = ee, ef = ie, nf = ne, lf = le, mf = me, af = ae, cf = ce, sf = se, pf = pe, gf = ge, Sf = Se, ff = fe, vf = ve, uf = ue, df = de, wf = we, kf = ke, Pf = Pe, Bf = Be, Cf = Ce, hf = he, Yf = Ye, yf = ye, Af = Ae, bf = be, Mf = Me, Vf = Ve, If = Ie, Lf = Le, Tf = Te, Ff = Fe, Hf = He, Ef = Ee, Gf = Ge, Uf = Ue, Wf = We, Df = De, xf = xe, Of = Oe, Rf = Re, qf = qe, Nf = Ne, Kf = Ke, zf = ze, Qf = Qe, Zf = Ze, jf = je, Jf = Je, Xf = Xe, _f = _e, $f = $e, ov = oi, rv = ri, tv = ti, ev = ei, iv = ii, nv = ni, lv = li, mv = mi, av = ai, cv = ci, sv = si, pv = pi, gv = gi, Sv = Si, fv = fi, vv = vi, uv = ui, dv = di, wv = wi, kv = ki, Pv = Pi, Bv = Bi, Cv = Ci, hv = hi, Yv = Yi, yv = yi, Av = Ai;
export {
  os as AddToFolder,
  rs as AddedtoFolder,
  ts as AiWand,
  es as AlarmBell,
  is as AlignBottom,
  ns as AlignCenter,
  ls as AlignLeft,
  ms as AlignMiddle,
  as as AlignRight,
  cs as AlignTop,
  ss as Amex,
  ps as ApplePay,
  gs as ArrowBack,
  Ss as ArrowCursorBlue,
  fs as ArrowCursorPink,
  vs as ArrowCursorYellow,
  us as ArrowDown,
  ds as ArrowRight,
  ws as ArrowUp,
  ks as Attachment,
  Ps as AudioModified,
  Bs as BlankCalendarBlue,
  Cs as BlankCalendarPink,
  hs as BlankCalendarYellow,
  Ys as Brain,
  ys as BusinessStartupBlue,
  As as BusinessStartupPink,
  bs as BusinessStartupYellow,
  Ms as Calendar,
  Vs as CameraBlue,
  Is as CameraPink,
  Ts as CameraVideoBlue,
  Fs as CameraVideoPink,
  Hs as CameraVideoYellow,
  Ls as CameraYellow,
  Es as ChatBubbleTypingOvalBlue,
  Gs as ChatBubbleTypingOvalPink,
  Us as ChatBubbleTypingOvalYellow,
  Ws as ChatTwoBubblesSquareBlue,
  Ds as ChatTwoBubblesSquarePink,
  xs as ChatTwoBubblesSquareYellow,
  Os as Check,
  Rs as CheckCircle,
  qs as ChevronDown,
  Ns as ChevronLeft,
  Ks as ChevronRight,
  zs as ChevronUp,
  Qs as CircleCheck,
  Zs as CircleClockBlack,
  js as CircleClockBlue,
  Js as CircleClockPink,
  Xs as CircleClockYellow,
  _s as Close,
  $s as Cog,
  op as CollapseContent,
  rp as Compass,
  tp as ControlsForward,
  ep as ControlsPause,
  ip as ControlsPlay,
  np as ControlsRecord,
  lp as ControlsRewind,
  mp as ControlsStop,
  ap as DashboardGaugeBlue,
  cp as DashboardGaugePink,
  sp as DashboardGaugeYellow,
  pp as DinersClub,
  gp as Discover,
  Sp as DownloadBottom,
  fp as DownloadSquareBlue,
  vp as DownloadSquarePink,
  up as DownloadSquareYellow,
  dp as Dropbox,
  wp as EmptyClipboardBlue,
  kp as EmptyClipboardPink,
  Pp as EmptyClipboardYellow,
  Bp as ErlenmeyerFlaskBlue,
  Cp as ErlenmeyerFlaskPink,
  hp as ErlenmeyerFlaskYellow,
  Yp as Error,
  yp as ExpandContent,
  Ap as ExpandHorizontal,
  bp as ExpandVertical,
  Mp as Facebook,
  Vp as Favorite,
  Ip as FavoriteFilled,
  Lp as FileDouble,
  Tp as Filter,
  Fp as FilterImage,
  Hp as FilterMusic,
  Ep as FilterPlus,
  Gp as FilterVideo,
  Up as FolderStar,
  Wp as GenerateImage,
  Dp as GenerateVideo,
  xp as GitHub,
  Op as GooglePay,
  Rp as GraphPieChartBlue,
  qp as GraphPieChartPink,
  Np as GraphPieChartYellow,
  Kp as GridRulesBlue,
  zp as GridRulesPink,
  Qp as GridRulesYellow,
  Zp as HappyFaceBlue,
  jp as HappyFacePink,
  Jp as HappyFaceYellow,
  Xp as HeadphonesCustomer,
  _p as HelpChatBlue,
  $p as HelpChatPink,
  og as HelpChatYellow,
  rg as HomeBlue,
  tg as HomePink,
  eg as HomeYellow,
  ig as HourGlassBlue,
  ng as HourGlassPink,
  lg as HourGlassYellow,
  mg as House,
  ag as Image,
  cg as ImageModified,
  sg as InformationCircle,
  pg as InformationCircleInverted,
  gg as Instagram,
  Sg as InterfaceAlertAlarmBellBlue,
  fg as InterfaceAlertAlarmBellPink,
  vg as InterfaceAlertAlarmBellYellow,
  ug as InterfaceAwardTrophyBlue,
  dg as InterfaceAwardTrophyPink,
  wg as InterfaceAwardTrophyYellow,
  kg as InterfaceCursorArrowBlue,
  Pg as InterfaceCursorArrowPink,
  Bg as InterfaceCursorArrowYellow,
  Cg as InterfaceFavoriteLikeBlue,
  hg as InterfaceFavoriteLikePink,
  Yg as InterfaceFavoriteLikeYellow,
  yg as InterfaceImageVideoAudioSubtitlesBlue,
  Ag as InterfaceImageVideoAudioSubtitlesPink,
  bg as InterfaceImageVideoAudioSubtitlesYellow,
  Mg as InterfaceLightingLightBulbBlue,
  Vg as InterfaceLightingLightBulbPink,
  Ig as InterfaceLightingLightBulbYellow,
  Lg as InterfaceSearchBlue,
  Tg as InterfaceSearchPink,
  Fg as InterfaceSearchYellow,
  Hg as Keep,
  Wg as KeyboardArrowRight,
  Eg as KeyboardBlue,
  Gg as KeyboardPink,
  Ug as KeyboardYellow,
  Dg as LayersBlue,
  xg as LayersPink,
  Og as LayersYellow,
  Rg as LayoutWindowBlue,
  qg as LayoutWindowPink,
  Ng as LayoutWindowYellow,
  Kg as LinkedIn,
  zg as LoadingRing,
  Qg as Lock,
  Zg as LockUnlock,
  jg as LoginBlue,
  Jg as LoginPink,
  Xg as LoginYellow,
  _g as LogoStoryblocks,
  $g as LogoStoryblocksGray,
  oS as LogoStoryblocksWhite,
  rS as Maestro,
  tS as MagicWandBlue,
  eS as MagicWandPink,
  iS as MagicWandYellow,
  nS as Maker,
  lS as Mastercard,
  mS as MeetingCamera,
  aS as MegaphoneBlue,
  cS as MegaphonePink,
  sS as MegaphoneYellow,
  pS as Microphone,
  gS as MicrophoneOff,
  SS as MoneyCashBillBlue,
  fS as MoneyCashBillPink,
  vS as MoneyCashBillYellow,
  uS as MoneyWalletBlue,
  dS as MoneyWalletPink,
  wS as MoneyWalletYellow,
  kS as MusicSound,
  PS as NavigationMenuHorizontal,
  BS as NavigationMenuVertical,
  CS as NewStickyNoteBlue,
  hS as NewStickyNotePink,
  YS as NewStickyNoteYellow,
  yS as OneFingerTapBlue,
  AS as OneFingerTapPink,
  bS as OneFingerTapYellow,
  MS as OpenBookBlue,
  VS as OpenBookPink,
  IS as OpenBookYellow,
  LS as PanelCollapse,
  TS as PanelExpand,
  FS as ParagraphLeftAlign,
  HS as ParagraphsCenterAlign,
  ES as ParagraphsRightAlign,
  GS as PayPal,
  US as PenBlue,
  WS as PenPink,
  DS as PenYellow,
  xS as Pencil,
  OS as PicturesFolderMemoriesBlue,
  RS as PicturesFolderMemoriesPink,
  qS as PicturesFolderMemoriesYellow,
  NS as PinBlue,
  KS as PinPink,
  zS as PinYellow,
  QS as Pinterest,
  ZS as PlayListBlue,
  jS as PlayListPink,
  JS as PlayListYellow,
  XS as PlayVideo,
  _S as Plus,
  $S as ProfileAvatar,
  of as Questionmark,
  rf as Refresh,
  tf as ScreenTvBlue,
  ef as ScreenTvPink,
  nf as ScreenTvYellow,
  lf as ScriptBlue,
  mf as ScriptPink,
  af as ScriptYellow,
  cf as Search,
  sf as SearchSimilar,
  pf as SettingMenu,
  gf as Share,
  Sf as ShoppingCartBlue,
  ff as ShoppingCartPink,
  vf as ShoppingCartYellow,
  uf as Snapchat,
  df as Sparkle,
  wf as Sparkles,
  kf as Stamp,
  Pf as StarFourSided,
  Bf as StopwatchBlue,
  Cf as StopwatchPink,
  hf as StopwatchYellow,
  Yf as Stripe,
  yf as SunCloudBlue,
  Af as SunCloudPink,
  bf as SunCloudYellow,
  Mf as TextBold,
  Vf as TextInputArea,
  If as TextItalic,
  Lf as TextStrikeThrough,
  Tf as TextStyle,
  Ff as TextUnderline,
  Hf as ThirdEye,
  Ef as ThumbDown,
  Gf as ThumbUp,
  Uf as Trash,
  Wf as TravelMapEarthBlue,
  Df as TravelMapEarthPink,
  xf as TravelMapEarthYellow,
  Of as Twitter,
  Rf as UploadBottom,
  qf as UploadCircleBlue,
  Nf as UploadCirclePink,
  Kf as UploadCircleYellow,
  zf as UserCircleSingleBlue,
  Qf as UserCircleSinglePink,
  Zf as UserCircleSingleYellow,
  jf as UserSingleBlue,
  Jf as UserSinglePink,
  Xf as UserSingleYellow,
  _f as Venmo,
  $f as VerticalSliderSquareBlue,
  ov as VerticalSliderSquarePink,
  rv as VerticalSliderSquareYellow,
  tv as Video,
  ev as VideoEditPeel,
  iv as VideoEditSplit,
  nv as VideoModified,
  lv as VideoPlayerAlternate,
  mv as View,
  av as ViewOff,
  cv as Visa,
  sv as VoiceMailBlue,
  pv as VoiceMailPink,
  gv as VoiceMailYellow,
  Sv as VolumeDown,
  fv as VolumeLevelHighBlue,
  vv as VolumeLevelHighPink,
  uv as VolumeLevelHighYellow,
  dv as VolumeMedium,
  wv as VolumeOff,
  kv as VolumeUp,
  Pv as WarningTriangle,
  Bv as Waveform,
  Cv as WebcamVideoBlue,
  hv as WebcamVideoPink,
  Yv as WebcamVideoYellow,
  yv as Youtube,
  Av as Zap
};
